import { observer } from 'mobx-react-lite';
import {
  Button,
  Card,
  Header,
  Input,
  Pagination,
  Segment,
} from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import LoadingComponent from '../../app/layout/LoadingComponent';
import EditUser from './EditUser';
import DeleteUser from './DeleteUser';
import RegisterForm from './RegisterForm';
import { useEffect, useState } from 'react';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import '../../app/common/MediaQuery/responsive-user-list.css';
import UnauthorizedMessage from '../UnauthorizedMessage';
import ImageTag from '../../features/Profile/RenderImage';
import './style.css';

export default observer(function UserList() {
  const {
    userStore: { userList, loadUsers, getEditUser, loadingInitial },
    modalStore,
    dashboardStore,
    commonStore,
    mediaAssetStore,
  } = useStore();
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [postsPerPage] = useState<any>(10);
  const [filterObj, setFilterObj] = useState<any>([]);
  const [searchValue, setSearchValue] = useState({
    displayName: '',
    email: '',
    username: '',
  });

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  const openEditUser = (id: string) => {
    getEditUser(id);
    mediaAssetStore.editModalOpen(true, id);
  };
  const searchFunc = (event: any, data: any) => {
    /*Code for Pagination - Start*/
    setCurrentPage(1);
    setSearchValue({
      ...searchValue,
      [data.name]: data.value,
    });
    /* Code for Pagination - End*/
    if (data.value.toString() !== '') {
      setFilterObj([
        ...filterObj?.filter(
          (o: any) => o.key.toString() !== data.name.toString(),
        ),
        {
          key: data.name.toString(),
          filterValue: data.value.toString(),
        },
      ]);
    } else {
      setFilterObj(
        filterObj?.filter(
          (o: any) => o.key.toString() !== data.name.toString(),
        ),
      );
    }
  };
  function filterFunc(obj: any) {
    const result = filterObj?.map((fc: any) =>
      obj[fc.key]
        ? obj[fc.key].toString()?.toLowerCase()?.includes(fc.filterValue?.toLowerCase()?.toString())
        : null,
    );
    if (result?.filter((e: any) => e === false).length === 0) return true;
    return false;
  }

  if (loadingInitial)
    return (
      <div style={{ marginTop: '10px' }}>
        <LoadingComponent content="Loading Users..." />
      </div>
    );
  return (
    <div className="users" style={{ position: 'relative' }}>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <LoadingComponent />
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('SRPPB08') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('SRPPB08') && (
        <>
          {mediaAssetStore.mediaAsset.deleteUserModalOpen ? (
            <DeleteUser />
          ) : null}
          {mediaAssetStore.mediaAsset.editmodal ? <EditUser /> : null}

          <Segment clearing responsive={true} className="userList-model">
            <Header
              icon="user"
              size="huge"
              dividing
              as="h1"
              content={
                (userLanguage[0].UserViewUser?.UVUL01 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              sub
              color="grey"
            />
            <div className="userList-container">
              {userList?.length > postsPerPage ? (
                <Pagination
                  className="user-list-pagination-div"
                  activePage={currentPage}
                  totalPages={Math.ceil(
                    Object.keys(userList?.filter(filterFunc)).length /
                      postsPerPage,
                  )}
                  onPageChange={(_e: any, data: any) =>
                    paginate(data.activePage)
                  }
                />
              ) : null}
              <div className="userList-search-input">
                <Input
                  style={{ minWidth: '200px' }}
                  name={'displayName'}
                  fluid
                  icon="search"
                  placeholder={'displayname'}
                  value={searchValue.displayName}
                  onChange={searchFunc}
                />

                <Input
                  style={{ minWidth: '200px' }}
                  name={'email'}
                  fluid
                  icon="search"
                  placeholder={'email'}
                  value={searchValue.email}
                  onChange={searchFunc}
                />
                <Input
                  style={{ minWidth: '200px' }}
                  name={'username'}
                  fluid
                  icon="search"
                  placeholder={'username'}
                  value={searchValue.username}
                  onChange={searchFunc}
                />

                {commonStore.filterModeTwo?.includes('UVUB01') ? (
                  <></>
                ) : (
                  <Button
                    disabled={commonStore.filterModeZero?.includes('UVUB01')}
                    className="userList-Register-btn"
                    positive
                    floated="right"
                    onClick={() => modalStore.openModal(<RegisterForm />)}
                    //Create User
                  >
                    {
                      (userLanguage[0].UserViewUser.UVUB01 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Button>
                )}
              </div>
            </div>
          </Segment>
          <Segment>
            <Card.Group className="userCard">
              {userList
                .filter(filterFunc)
                .slice(
                  parseInt(currentPage, 10) * parseInt(postsPerPage, 10) -
                    parseInt(postsPerPage, 10),
                  parseInt(currentPage, 10) * parseInt(postsPerPage, 10),
                )
                .map((user: any) => (
                  <>
                    {user.isDeleted === false && (
                      <Card key={user.id} className="usercardinterface">
                        <Card.Content>
                          <ImageTag
                            imageUrl={user?.image}
                            defaultUrl="/assets/user.png"
                            fluid={true}
                            style={{
                              marginBottom: '10px',
                            }}
                          />
                          <Card.Header>{user.displayName}</Card.Header>
                          <Card.Meta>{user.email}</Card.Meta>
                          <Card.Description>{user.username}</Card.Description>
                        </Card.Content>
                        <Card.Content extra>
                          <div className="ui two buttons">
                            <>
                              {!user.isAdmin &&
                              commonStore.filterModeTwo?.includes('UVUB02') ? (
                                <></>
                              ) : (
                                <Button
                                  basic
                                  color="green"
                                  onClick={() => openEditUser(user.id)}
                                  disabled={
                                    !user.isAdmin &&
                                    commonStore.filterModeZero?.includes(
                                      'UVUB02',
                                    )
                                  }
                                  //Edit
                                >
                                  {
                                    (
                                      userLanguage[0].UserViewUser.UVUB02 as any
                                    )?.[`${commonStore.language.key}`]
                                  }
                                </Button>
                              )}

                              {!user.isAdmin &&
                              commonStore.filterModeTwo?.includes('UVUB03') ? (
                                <></>
                              ) : (
                                <Button
                                  onClick={() =>
                                    mediaAssetStore.openDeleteUserModal(
                                      true,
                                      user.id,
                                      user.displayName,
                                    )
                                  }
                                  basic
                                  color="red"
                                  disabled={
                                    !user.isAdmin &&
                                    commonStore.filterModeZero?.includes(
                                      'UVUB03',
                                    )
                                  }
                                  //Delete
                                >
                                  {
                                    (
                                      userLanguage[0].UserViewUser.UVUB03 as any
                                    )?.[`${commonStore.language.key}`]
                                  }
                                </Button>
                              )}
                            </>
                          </div>
                        </Card.Content>
                      </Card>
                    )}
                  </>
                ))}
            </Card.Group>
          </Segment>
        </>
      )}
    </div>
  );
});
